import { render } from "./packsix.vue?vue&type=template&id=4a6134e2&scoped=true"
import script from "./packsix.vue?vue&type=script&lang=js"
export * from "./packsix.vue?vue&type=script&lang=js"

import "./packsix.vue?vue&type=style&index=0&id=4a6134e2&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6134e2"]])

export default __exports__